import { memo, useEffect, useState } from 'react'
import LazyLoad from 'react-lazyload'

import Ad from '@/components/Ad/Ad'
import { useAds } from '@/contexts/ads'

import styles from './Leaderboard.module.scss'

const Leaderboard = () => {
  const { loadAds } = useAds()
  const [randomRoll, setRandomRoll] = useState<number>(0)

  // Reroll ad every minute
  useEffect(() => {
    setRandomRoll(Math.random())
    const interval = setInterval(() => {
      setRandomRoll(Math.random())
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  if (loadAds === false) return null

  /* Ad Setup:
     - Dueling Guard 10%

     - Half of remainder split between SCM
     - Other half of remainder goes to EDHREC Patreon
  */
  const ad =
    randomRoll === 0 ? null : randomRoll < 0.1 ? (
      <Ad id='duelingGuard' />
    ) : randomRoll < 0.1 + 0.9 * (1 / 14) ? (
      <Ad id='archidekt' />
    ) : randomRoll < 0.1 + 0.9 * (2 / 14) ? (
      <Ad id='cs' />
    ) : randomRoll < 0.1 + 0.9 * (3 / 14) ? (
      <Ad id='csb' />
    ) : randomRoll < 0.1 + 0.9 * (4 / 14) ? (
      <Ad id='edhrecap' />
    ) : randomRoll < 0.1 + 0.9 * (5 / 14) ? (
      <Ad id='edhrecast1' />
    ) : randomRoll < 0.1 + 0.9 * ((5 + 1 / 3) / 14) ? (
      <Ad id='edhrecast2' />
    ) : randomRoll < 0.1 + 0.9 * ((5 + 2 / 3) / 14) ? (
      <Ad id='edhrecast3' />
    ) : randomRoll < 0.1 + 0.9 * (6 / 14) ? (
      <Ad id='fabrec' />
    ) : randomRoll < 0.1 + 0.9 * (6.25 / 14) ? (
      <Ad id='spellifyDark1' />
    ) : randomRoll < 0.1 + 0.9 * (6.5 / 14) ? (
      <Ad id='spellifyDark2' />
    ) : randomRoll < 0.1 + 0.9 * (6.75 / 14) ? (
      <Ad id='spellifyLight1' />
    ) : randomRoll < 0.1 + 0.9 * (7 / 14) ? (
      <Ad id='spellifyLight2' />
    ) : randomRoll < 0.1 + 0.9 * (7 / 14 + 1 / 8) ? (
      <Ad id='edhrecPatreon' />
    ) : randomRoll < 0.1 + 0.9 * (7 / 14 + 2 / 8) ? (
      <Ad id='edhrecPatreon201' />
    ) : randomRoll < 0.1 + 0.9 * (7 / 14 + 3 / 8) ? (
      <Ad id='edhrecPatreon202' />
    ) : (
      <Ad id='edhrecPatreon203' />
    )

  if (loadAds === undefined) return <div className={styles.container} />

  return (
    <div className={styles.container}>
      <div className={styles.leaderboard}>
        <LazyLoad>{ad}</LazyLoad>
      </div>
    </div>
  )
}

export default memo(Leaderboard)
